import { get } from 'lodash';
import React from 'react';
import { KOSTEN_ARTEN, KOSTEN_POSITION } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import {
	checkIfAllPositionIsEditable,
	checkIfAnyPositionNachKostenArtHasComment,
	checkIfHasComment,
	checkIfProjektDatenHasComment,
} from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import { TreeStructureAntragAbschlussSeiteGlobal } from '../../global-structure/abschluss-seite/TreeStructureAbschlussSeiteGlobal';
import { TreeStructureAllgemeinHinweisGlobal } from '../../global-structure/allgemeinen-hinweis/TreeStructureAllgemeinHinweisGlobal';
import { TreeStructureAnlagenGlobal } from '../../global-structure/anlagen/TreeStructureAnlagenGlobal';
import { TreeStructureAntragBescheidGlobal } from '../../global-structure/antrag-bescheid/TreestructureAntragBescheidGlobal';
import { TreeStructureAntragstellerGlobal } from '../../global-structure/antragstellerin/TreeStructureAntragstellerGlobal';
import { TreeStructureDeMinimisGlobal } from '../../global-structure/de-minimis/TreeStructureDeMinimisGlobal';
import { TreeStructureErklaerungGlobal } from '../../global-structure/erklaerung/TreeStructureErklaerungGlobal';
import { TreeStructureSelbstErklaerungRUSGlobal } from '../../global-structure/rus-erklaerung/TreeStructureSelbstErklaerungRUSGlobal';
import { TreeStructureSelbstErklaerungKMUGlobal } from '../../global-structure/selbst-erklaerung-kmu/TreeStructureSelbstErklaerungKMUGlobal';
import { TreeStructureSelbstErklaerungBeihilferelevanzGlobal } from '../../global-structure/beihilferelevanz-erklaerung/TreeStructureSelbstErklaerungBeihilferelevanzGlobal';
import { TreeStructureAntragVorzeitigerMassnahme } from '../../global-structure/vorzeitige-massnahme/TreeStructureVorzeitigeMassnahmeGlobal';
import { TreeStructureZeitplanungGlobal } from '../../global-structure/zeitplanung/TreeStructureZeitplanungGlobal';
import EinnahmenAntragStipendium, { getFormStrucEinnahmenAntragStipendium } from './content/einnahmen/EinnahmenAntragStipendium';
import EinnahmenUebersichtAntragStipendium from './content/einnahmen/EinnahmenUebersichtAntragStipendium';
import FinanzierungsplanStipendium, { getFormStrucFinanzierungsplanStipendium } from './content/finanzierungsplan/FinanzierungsplanStipendium';
import PersonalkostenAntragStipendium, { getFormStrucPersonalkostenAntragStipendium } from './content/personalkosten/PersonalkostenAntragStipendium';
import PersonalkostenUebersichtAntragStipendium from './content/personalkosten/PersonalkostenUebersichtAntragStipendium';
import ProjektbeschreibungAntragStipendium, { getFormStrucProjektbeschreibungAntragStipendium } from './content/ProjektbeschreibungAntragStipendium';
import ProjektDatenAntragStipendium, { getFormStrucProjektDatenAntragStipendium } from './content/ProjektdatenAntragStipendium';
import SachkostenAntragStipendium, { getFormStrucSachkostenAntragStipendium } from './content/Sachkosten/SachkostenAntragStipendium';
import SachkostenUebersichtAntragStipendium from './content/Sachkosten/SachkostenUebersichtAntragStipendium';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

export const TreeStructureAntragStipendium = (
	application: any,
	readOnly: boolean,
	kostenKategories: any[],
	kostenKategoriesGroup: any,
	allgemeineHinweiseKMU: any,
	allgemeineHinweiseDeminimis: any,
	allgemeineHinweiseRUS: any,
	allgemeineHinweiseBeihilferelevanz: any,
): TreeNodeType[] => {
	const hasCommentProjektdaten = checkIfProjektDatenHasComment(readOnly, application);
	const isKostenEditable = checkIfAllPositionIsEditable(readOnly, application);

	let treeNodes: TreeNodeType[] = [
		// Allgemeine Hinweise Global
		...TreeStructureAllgemeinHinweisGlobal(application),
		// Projektdaten
		{
			label: 'Projektdaten',
			content: <ProjektDatenAntragStipendium hasComment={hasCommentProjektdaten} />,
			formStruc: getFormStrucProjektDatenAntragStipendium(application),
			hasComment: hasCommentProjektdaten,
		},
		// Antragsteller Global
		...TreeStructureAntragstellerGlobal(application, readOnly),
		// Projektbeschreibung zu Unternehmensstatus
		...ProjektbeschreibungStructure(application, readOnly),
		// Selbsterlärung-KMU Global
		...TreeStructureSelbstErklaerungKMUGlobal(application, readOnly, allgemeineHinweiseKMU),
		// Beihilferelevanz-Erklärungen Global
		...TreeStructureSelbstErklaerungBeihilferelevanzGlobal(application, readOnly, allgemeineHinweiseBeihilferelevanz),
		// RUS-Erklärungen Global
		...TreeStructureSelbstErklaerungRUSGlobal(application, readOnly, allgemeineHinweiseRUS),
		// Deminismis-Selbsterklärung Global
		...TreeStructureDeMinimisGlobal(application, readOnly, allgemeineHinweiseDeminimis),
		// Kosten
		...PersonalKostenStructure(application, kostenKategories, kostenKategoriesGroup, readOnly, isKostenEditable),
		...SachkostenStruktur(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		...EinnahmeStructure(application, kostenKategories, kostenKategoriesGroup, readOnly, isKostenEditable),
		//Finanzierungsplan Global
		{
			label: 'Ausgaben- und Finanzierungsplan',
			content: <FinanzierungsplanStipendium />,
			formStruc: getFormStrucFinanzierungsplanStipendium(application),
			hasComment: isKostenEditable,
			isSummaryReport: true,
		},
		// Zeitplanung Global
		...TreeStructureZeitplanungGlobal(application, readOnly),
		// Anlagen und Erklärung Global
		...TreeStructureAnlagenGlobal(application, readOnly),
		...TreeStructureErklaerungGlobal(application, readOnly),
		// Vorzeitiger Massnahme Global
		...TreeStructureAntragVorzeitigerMassnahme(application, readOnly),
		// Abschluss Global
		...TreeStructureAntragAbschlussSeiteGlobal(application, readOnly),
		// Bescheid Global
		...TreeStructureAntragBescheidGlobal(application),
	];

	return treeNodes;
};

const ProjektbeschreibungStructure = (application: any, readOnly: boolean) => {
	const hasCommentProjektbeschreibung = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Startup_Stipendium.schema.attributes.Pruefstatus.path,
	);
	let nodes: TreeNodeType[] = [
		{
			label: 'Unternehmensstatus',
			content: <ProjektbeschreibungAntragStipendium hasComment={hasCommentProjektbeschreibung} />,
			formStruc: getFormStrucProjektbeschreibungAntragStipendium(application),
			hasComment: hasCommentProjektbeschreibung,
		},
	];

	return nodes;
};
const PersonalKostenStructure = (
	application: any,
	kostenKategories: any[],
	kostenKategoriesGroup: any,
	readOnly: boolean,
	hasCommentAusgabenUndFinanzierung?: boolean,
) => {
	let nodes: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Personalkosten)) {
		nodes = [
			{
				label: 'Personalkosten',
				content: <PersonalkostenAntragStipendium hasComment={hasCommentAusgabenUndFinanzierung} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Personalkosten),
				formStruc: getFormStrucPersonalkostenAntragStipendium(
					application,
					kostenKategories,
					get(application, `${P.Antragstellende_Organisation.path}.id`),
				),
			},
			{
				label: 'Personalkosten Übersicht',
				content: <PersonalkostenUebersichtAntragStipendium />,
				isSummaryReport: true,
			},
		];
	}
	return nodes;
};
const SachkostenStruktur = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	let nodes: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Sachkosten)) {
		nodes = [
			{
				label: 'Sachkosten',
				content: <SachkostenAntragStipendium hasComment={hasCommentAusgabenUndFinanzierung} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Sachkosten),
				formStruc: getFormStrucSachkostenAntragStipendium(application, get(application, `${P.Antragstellende_Organisation.path}.id`)),
			},
			{
				label: 'Sachkosten Übersicht',
				content: <SachkostenUebersichtAntragStipendium />,
				isSummaryReport: true,
			},
		];
	}
	return nodes;
};
const EinnahmeStructure = (
	application: any,
	kostenKategories: any[],
	kostenKategoriesGroup: any,
	readOnly: boolean,
	hasCommentAusgabenUndFinanzierung?: boolean,
) => {
	let nodes: TreeNodeType[] = [];

	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Einnahme, []).includes(KOSTEN_ARTEN.Eigenmittel)) {
		nodes = [
			{
				label: 'Eigen- und Drittmittel',
				content: <EinnahmenAntragStipendium hasComment={hasCommentAusgabenUndFinanzierung} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Eigenmittel),
				formStruc: getFormStrucEinnahmenAntragStipendium(
					application,
					kostenKategories,
					get(application, `${P.Antragstellende_Organisation.path}.id`),
				),
			},
			{
				label: 'Eigen- und Drittmittel Übersicht',
				content: <EinnahmenUebersichtAntragStipendium />,
				isSummaryReport: true,
			},
		];
	}
	return nodes;
};
